module.exports = __webpack_public_path__ + "img/info.00933455.svg";